var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"safe-box"},[_c('Header',{attrs:{"isSafeBox":""}}),_c('VideoAnimate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }